import { CourierSettlementsApiAdapter } from '../../adapters';
import type { CourierSettlementLinesFilters } from '../../models/settlementLinesFilters';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import type { FormattedError } from '@shared/utils/RequestUtils';
import { useMutation } from '@tanstack/react-query';
import { useMemo } from 'react';

export const useCourierSettlementLinesExport = (settlementId: number) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const adapter = useMemo(() => new CourierSettlementsApiAdapter(httpClient), [httpClient]);

  return useMutation({
    mutationFn: async (filters: CourierSettlementLinesFilters) => {
      const { url_file } = await adapter.linesExport(settlementId, filters);
      if (url_file) {
        window.open(url_file, '_blank');
      }
    },
  });
};

export function isSettlementLinesExportNotFoundError(error: unknown): boolean {
  const e = error as FormattedError & { statusCode?: number; response?: { status?: number } };
  const code = e?.statusCode ?? e?.response?.status;
  return code === 404;
}
